var exports = {
  "L": "warningOverride__GwgTRP",
};

module.exports = exports;
